import { Icon } from "@components/Icon";
import ModalsPopup from "@components/Modals/ModalsPopup";
import React from "react";
import tw, { styled } from "twin.macro";
import AddToCartErrorPopup from "../AddToCart/AddToCartErrorPopup";
import FindInStorePopup from "./FindInStorePopup";
import { FindInStoreOutputProps, withFindInStore } from "./withFindInStore";
import { Button } from "@bared/ui";

const Content = styled(FindInStorePopup)`
  ${tw`w-full`}
`;

const Wrapper = tw.div`
  w-auto flex items-center justify-start transition-presentation hover:text-secondary
`;

const StyledIcon = tw(Icon)`
  mr-pico
`;

export const FindInStore = withFindInStore(
  ({
    active,
    setActive,
    handleClick,
    additionalFindInStore,
    countryCode,
    errorActive,
    setErrorActive,
    selectedVariant,
  }: FindInStoreOutputProps) => {
    return (
      <>
        <Wrapper>
          <StyledIcon name="map-pin" size="xxs" />
          <Button variant="link" onClick={handleClick}>
            {additionalFindInStore}
          </Button>
        </Wrapper>
        <AddToCartErrorPopup active={errorActive} setActive={setErrorActive} />
        <ModalsPopup layout="notify" active={active} setActive={setActive}>
          <Content
            active={active}
            setActive={setActive}
            countryCode={countryCode}
            selectedVariant={selectedVariant}
          />
        </ModalsPopup>
      </>
    );
  },
);
